import state from './moduleDomainState'
import actions from './moduleDomainActions'
import getters from './moduleDomainGetters'
import mutations from './moduleDomainMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
